export default "__VITE_ASSET__CCt5AtoX__"